
import { Button, Divider, Grid, Typography } from "@mui/material";
import { ErrorMessage, Form, Formik } from 'formik';
import DatePicker from "react-datepicker";
import { IEntityToDisable } from "../models/entityToDisable";

import "react-datepicker/dist/react-datepicker.css";
import '../themes/styles.css';

interface Props {
    onCancel: () => void,
    onDisable: (values: IEntityToDisable) => void,
    entity: IEntityToDisable
}

export const MyToDisableForm = ({ onCancel, onDisable, entity }: Props) => {
    return (
        <Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                {entity.name}
            </Typography>
            <br />
            <Divider />
            <br />

            <Formik
                initialValues={entity}
                onSubmit={(values) => {
                    onDisable(values as IEntityToDisable);
                    onCancel();
                }}
            // validationSchema={Yup.object({
            //     name: Yup.string()
            //         .max(15, 'Debe de tener 15 caracteres o menos')
            //         .required('Requerido'),
            // }) } 
            >

                {(formik) => (
                    <Form>
                        <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="availableQuantity">Active Until Date</Typography>
                                <DatePicker
                                    autoComplete="off"
                                    selected={(formik.values.activeUntilDate && new Date(formik.values.activeUntilDate)) || null}
                                    dateFormat="MMMM d, yyyy"
                                    className="form-control"
                                    name="activeUntilDate"
                                    onChange={(date: any) => formik.setFieldValue('activeUntilDate', date)}
                                />
                                <ErrorMessage name="availableQuantity" component="span" className="error-message" />
                                <br />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container justifyContent="center">
                            <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button variant="contained" type="submit" sx={{ width: 100 }} >Save</Button>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Grid >
    )
}
